import React from 'react';
import { marked } from 'marked';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { css } from 'styled-components';
import { DefaultRenderer } from './Markdown/DefaultRenderer';
export const youtubeIdRegex = /^https:\/\/(?:www\.youtube\.com\/watch\?v=|youtu\.be\/)([^/&\s]+)/i;
export const spotifyVideoRegex = /^https:\/\/(?:open\.spotify\.com|spotify\.com)\/(?:video\/|embed\/episode\/[^/]+\/video)/i;
export const withoutProps = (Component, ...excludeProps) => props => {
    const { children, ...compProps } = props;
    for (const prop of excludeProps) {
        delete compProps[prop];
    }
    return React.createElement(Component, { ...compProps }, children);
};
export function useScrollYPosition() {
    const [y, setY] = React.useState(0);
    useScrollPosition(({ currPos }) => {
        setY(currPos.y);
    }, []);
    return y;
}
export function formatText(str) {
    return marked.parseInline((str || '').trim().replace(/(\\n|\n)/g, '<br />'), {
        xhtml: true,
        smartypants: true,
        renderer: new DefaultRenderer(),
    });
}
export const responsiveText = (defaultStyle, breakpoints) => css `
  ${defaultStyle};
  // style is broken down from encore var values
  ${Object.entries(breakpoints).map(([breakpoint, style]) => `
    @media (min-width: ${breakpoint}) {
      font-size: ${style.fontSize};
      font-family: ${style.fontFamily};
      font-weight: ${style.fontWeight};
    }
  `)}
`;
export const transformScaleUp = `transform: scale(1.05);`;
export function isContentfulImage(url) {
    return (url &&
        (url.includes('images.ctfassets.net') ||
            url.includes('images.contentful.com')));
}
export const isValidPath = (url) => {
    if (url) {
        const decoded = decodeURIComponent(url);
        return (!decoded.includes('\\') &&
            !decoded.match(/^\/\//) &&
            !decoded.match(/^.+:.+/));
    }
    return false;
};
export const getBurst = (color) => {
    return css `
    background-image: url("
      data:image/svg+xml,%3Csvg
      width='465'
      height='225'
      viewBox='0 0 465 224'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'%3E%3Cpath
      d='M1 223L332.118 2L250.776 207.016L353.662 123.272L336.101 184.082L465 106.069'
      stroke='%23${color.substring(1)}'/%3E%3C/svg%3E
    ");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: right center;
  `;
};
export const mergeRefs = (...refs) => {
    const filteredRefs = refs.filter(Boolean);
    if (!filteredRefs.length)
        return null;
    if (filteredRefs.length === 1)
        return filteredRefs[0];
    return (inst) => {
        for (const elementRef of filteredRefs) {
            if (typeof elementRef === 'function') {
                elementRef(inst);
            }
            else if (elementRef) {
                elementRef.current = inst;
            }
        }
    };
};
